import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { VideoDialogComponent } from 'src/app/components/video-dialog/video-dialog.component';
import { CapabilityType } from '../../../models/service/capability';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { translate } from '@jsverse/transloco';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';

@Component({
    selector: 'app-solution-summary',
    templateUrl: './solution-summary.component.html',
    styleUrls: ['./solution-summary.component.scss'],
    standalone: false
})
export class SolutionSummaryComponent  implements OnInit {

  CapabilityType = CapabilityType;
  RouterSegments = RouterSegments;
  solutionId: string;
  tenant: string;
  solutionDetails: any;
  solutionVersions: any;
  capabilitiesGroups: any;
  breadcrumbItems: BreadcrumbItem[] = [];
  showSpinner: any;
  isFailed = false;
  private destroyRef = inject(DestroyRef);


  constructor(private activatedRoute: ActivatedRoute, private toastrService: CustomToastrService,
    private solutionsService: SolutionsService, private authService: AuthService,
    private matDialog: MatDialog, private sidenavService: SidenavService, private toastrErrorService: ToastrErrorService) {
      
     }

  ngOnInit(): void {
    this.sidenavService.selectedMenu = 'LEFT_SIDE_NAV.SOLUTIONS';
    this.tenant = this.authService.principal.provider;
    this.solutionId = this.activatedRoute.snapshot.params.solutionId;

    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg'},
      {label: translate('LEFT_SIDE_NAV.SOLUTION_ONBOARDING')},
      {label: translate('LEFT_SIDE_NAV.SOLUTIONS'), url: ['solutions']});

    this.getSolutionDetails();
    this.getSolutionVersions();
  }

  getSolutionDetails(): void {
    this.showSpinner = true;
    this.isFailed = false;
    this.solutionsService.getSolutionById(this.solutionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.solutionDetails = data;
          if (this.solutionDetails?.name) {
            this.breadcrumbItems.push({label: this.solutionDetails?.name});
          }
          this.showSpinner = false;
        }
      },
      (error) => {
        this.showSpinner = false;
        this.isFailed = true;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  getSolutionVersions(): void {
    this.solutionsService.getSolutionVersions(this.solutionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.solutionVersions = data[0];
          if (this.solutionVersions?.capabilities?.length > 0) {
            const capabilitiesByType = this.solutionVersions?.capabilities
              .reduce((acc, capability) => {
                if (capability.required !== CapabilityType.OPTIONAL) {
                  capability.selected = true;
                }

                let capabilitiesArr = acc[capability.required];
                if (capabilitiesArr == null) {
                  capabilitiesArr = [];
                  acc[capability.required] = capabilitiesArr;
                }
                capabilitiesArr.push(capability);
                return acc;
              }, {});
            this.capabilitiesGroups = Object.keys(capabilitiesByType)
              .map(capabilityType => ({ name: capabilityType, capabilities: capabilitiesByType[capabilityType] }));
            }
        }
      },
      (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  openVideo(): void {
    this.matDialog.open(VideoDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      autoFocus: false,
      data: {
        videoHref: this.solutionDetails.media[0].mediaHref
      }
    });
  }

}
